import { type UseCodeMirror, useCodeMirror } from "@uiw/react-codemirror";
import { clsx } from "clsx";
import { type CSSProperties, type FC, useEffect, useRef } from "react";
import { useResizeObserver } from "widgets/hooks";

interface FilePreviewTextFieldProps extends Pick<UseCodeMirror, "value"> {
  isLoading?: boolean;
  style?: CSSProperties;
}

export const FilePreviewTextField: FC<FilePreviewTextFieldProps> = (props) => {
  const contentSizeRef = useRef<HTMLDivElement>(null);
  const contentBoxSize = useResizeObserver(contentSizeRef);
  const editorRef = useRef<HTMLDivElement>(null);

  const { setContainer } = useCodeMirror({
    value: props.isLoading ? "Please wait..." : props.value,
    height: `${contentBoxSize?.height}px`,
    width: `${contentBoxSize?.width}px`,
    readOnly: true,
    autoFocus: false,
  });

  useEffect(() => {
    if (editorRef.current) {
      setContainer(editorRef.current);
    }
  }, [setContainer]);

  return (
    <div
      className={clsx("cm-script-editor", { "cm-disabled": props.isLoading })}
      style={props.style}
      data-testid="text-file-preview"
      ref={contentSizeRef}
    >
      <div ref={editorRef} />
    </div>
  );
};
